'use strict';

module.exports = {
    IN_PROGRESS: 'IN_PROGRESS',
    TRANSFERRED: 'TRANSFERRED',
    CANCELLED: 'CANCELLED',
    ERROR: 'ERROR',
    QUEUED: 'QUEUED'
};